interface LogData {
  timestamp: number;
  [key: string]: any;
}

export const logEvent = (type: string, data?: Record<string, any>) => {
  const logData: LogData = {
    timestamp: Date.now(),
    ...data
  };

  // Log para console em desenvolvimento
  if (process.env.NODE_ENV === 'development') {
    console.log(`[${type}]`, logData);
  }

  // Em produção, enviar para serviço de analytics
  if (process.env.NODE_ENV === 'production') {
    // Implementar envio para serviço de analytics
    // Ex: Google Analytics, Sentry, etc.
  }
};

export const logError = (type: string, data?: Record<string, any>) => {
  const errorData: LogData = {
    timestamp: Date.now(),
    ...data
  };

  // Log para console em desenvolvimento
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${type}]`, errorData);
  }

  // Em produção, enviar para serviço de monitoramento
  if (process.env.NODE_ENV === 'production') {
    // Implementar envio para serviço de monitoramento
    // Ex: Sentry, LogRocket, etc.
  }
}; 